import { makeApi } from "./callApi";

export class FeeApi {
    static async getDeliveryFee(payload) {
        const response = await makeApi("/fee/calculate/order", "POST", payload);
        return response.data;
    }
}
